import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { DNumberFormControl } from "../../entities/form-control";
import { FormField } from "../../entities/form-field";

@Component({
	selector: "form-number",
	template: `
		<div class="dynamic-field form-number" [formGroup]="group">
			<label>
				<ng-content select="h3" />

				<input-text-icon class="text-icon__prefix" [data]="config.prefix" />

				<input-text-icon class="text-icon__suffix" [data]="config.suffix" />

				<input
					type="number"
					[formControlName]="config.name"
					[max]="config.max"
					[min]="config.min"
					[placeholder]="placeholder | i18n"
					[step]="config.step"
				/>
			</label>
		</div>
	`,
	styleUrls: ["../form-style.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FormNumberComponent implements FormField {
	@Input() config: DNumberFormControl;
	@Input() group: UntypedFormGroup;

	get placeholder() {
		return this.config.placeholder || "";
	}
}
